<template>
  <article class="rounded-lg p-2 transition-all duration-200 hover:shadow-md" :class="[alert.isRead ? 'bg-bhav-cool-gray-50' : 'bg-bhav-blue-50']" :id="`alert-${alert.id}`">
    <div class="flex justify-between items-center mb-1 gap-1 relative">
      <time datetime="{{ alert.created_at }}" class="text-xs text-gray-400 flex-1">
        {{ alert.date }}
      </time>
      <p class="text-xs text-gray-400 flex-0">
        {{ alert.since }}
      </p>
      <span v-if="!alert.isRead" class="w-1 aspect-square bg-oakwood-red-500 rounded-full"></span>
    </div>
    <section class="bg-white p-1 rounded-lg flex flex-col gap-2">
      <h2 class="rounded-lg" :class="[alert.isRead ? 'text-bhav-blue-500 bg-bhav-cool-gray-50' : 'text-white bg-bhav-blue-500']">
        <component :is="alert?.log?.model && alert.url !== false ? 'router-link' : 'p'" :to="alert.url" class="p-3 flex gap-2 items-start" :class="{'cursor-pointer' : alert.url}">
          <div class="rounded-full aspect-square bg-white p-1.5 text-black flex items-center justify-center"><span class="text-xl fak text-bhav-blue-500" :class="alert.icon" :title="alert?.log?.model_type"></span></div>
          <span>{{ alert.headline }}</span>
        </component>
      </h2>
      <div class="text-sm text-gray-600" v-if="isExpanded">
        <ul v-if="['agent_collection','attachment'].includes(alert.log.model_type)" class="flex flex-col gap-2" :class="{ 'line-clamp-3': !isExpanded }">
            <li v-for="content,id in alert.contents" :key="`log-${id}`" class="text-sm text-bhav-blue-300 leading-loose">
              <span class="text-bhav-blue-500 bg-bhav-cool-gray-50 p-1 rounded-sm">{{ content }}</span>
            </li>
        </ul>
        <ul v-else class="flex flex-col gap-2" :class="{ 'line-clamp-3': !isExpanded }">
            <li v-for="difference,d in alert.diffs" :key="`difference-${d}`" class="text-sm text-bhav-blue-300 leading-loose">
              <span class="text-bhav-blue-500 bg-bhav-cool-gray-50 p-1 rounded-sm">{{ getLabel(d) }}</span> was set to <span class="text-bhav-blue-500 bg-bhav-bright-blue-50 p-1 rounded-sm">{{ getValue(difference) }}</span>
            </li>
        </ul>
      </div>
    </section>
    <div class="cursor-pointer flex items-center py-1 text-bhav-blue-300" @click="toggleExpanded" v-if="alert.details">
      <p v-text="isExpanded ? 'Hide Details' : 'Show Details'" class="text-[.625rem] flex-1"></p>
      <p class="far flex-0" :class="[isExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></p>
    </div>
  </article>
</template>

<script>
import { AlertsController } from '@/controllers/alerts';
import English from '@/enums/English';
import Alert from '@/models/alert';

export default {
  name: "AlertItem",
  props: {
    alert: {
      type: Alert,
      required: true
    }
  },
  data() {
    return {
      isExpanded: false,
      maxCollapsedItems: 3,
    }
  },
  emits: [
    'close'
  ],
  methods: {
    getLabel(key) {
      return English.label(key);
    },
    getValue(difference) {
      return English[`value:${difference}`] ?? difference.length > 100 ? `${difference.slice(0,100)}...` : difference;
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
      if(!this.alert.isRead) {
        this.markAsRead(this.alert);
      }
    },
    markAsRead(alert) {
      alert.read = !alert.isRead;
      AlertsController.update(alert)
        .then(res => {
          alert.read_at = alert.isRead ? null : new Date().toISOString();
        })
        .catch(e => {
          throw e;
        });
    },
    markAndClose(alert) {
      // only call markAsRead if the alert is unread
      if(!alert.isRead) {
        this.markAsRead(alert);
      }
      this.$emit('close');
    }
  }
}
</script>